import { Link } from "react-router-dom";
import { Sparkle } from "lucide-react";
import { useSite } from "../siteContext";

/* Slim campaign announcement bar — controlled from Admin → Marketing (promo_* settings). Hidden when off. */
export const AnnouncementBar = () => {
  const s = useSite();
  if (!s.promo_on || !s.promo_link) return null;
  return (
    <Link
      to={s.promo_link}
      data-testid="announcement-bar"
      className="relative z-50 flex items-center justify-center gap-2.5 bg-luxury-black border-b border-luxury-gold/30 px-4 py-2.5 text-center transition-colors hover:bg-luxury-surface"
    >
      <Sparkle className="w-3.5 h-3.5 text-luxury-gold shrink-0" strokeWidth={1.5} />
      <span className="text-xs md:text-sm text-luxury-bone tracking-wide">
        <span className="text-luxury-gold font-semibold">PROJECT MAGNETIC</span>
        <span className="text-luxury-gray mx-2">—</span>
        {s.promo_text}
      </span>
      <span className="text-xs md:text-sm font-bold text-luxury-gold whitespace-nowrap border-b border-luxury-gold/50 pb-0.5">
        {s.promo_cta}
      </span>
    </Link>
  );
};
